import { adminApi } from "../../../api/adminClient";
import { cloneFormData, unwrapList, unwrapOne } from "../utils/adminApiHelpers";

export { unwrapList, unwrapOne };

export function buildNewsFormData(data) {
  const fd = new FormData();
  fd.append("title_ar", String(data.title_ar ?? "").trim());
  fd.append("title_en", String(data.title_en ?? "").trim());
  fd.append("content_ar", String(data.content_ar ?? "").trim());
  fd.append("content_en", String(data.content_en ?? "").trim());

  const list = data.image;
  const file =
    list && typeof list.length === "number" && list.length > 0
      ? list[0]
      : null;
  if (file instanceof File && file.size > 0) {
    fd.append("image", file);
  }
  return fd;
}

export function buildNewsFormDataForUpdate(data) {
  const fd = buildNewsFormData(data);
  fd.append("title[ar]", String(data.title_ar ?? "").trim());
  fd.append("title[en]", String(data.title_en ?? "").trim());
  fd.append("content[ar]", String(data.content_ar ?? "").trim());
  fd.append("content[en]", String(data.content_en ?? "").trim());
  return fd;
}

export const fetchAdminNewsList = () => adminApi.get("/news");

export const fetchAdminNewsById = (id) => adminApi.get(`/admin/news/${id}`);

export const createAdminNews = (formData) =>
  adminApi.post("/admin/news", formData);

export const updateAdminNews = (id, formData) => {
  const fd = cloneFormData(formData);
  fd.append("_method", "PUT");
  return adminApi.post(`/admin/news/${id}`, fd);
};

export const deleteAdminNews = (id) => adminApi.delete(`/admin/news/${id}`);
